import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NotificationType } from '@app/shared/interfaces';
import { SettingsService } from '@app/shared/services/settings/settings.service';
import { TitleService } from '@app/shared/services/title/title.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { invert } from 'lodash-es';

@Component({
  standalone: false,
  selector: 'sbnb-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.scss'],
})
export class SecurityComponent implements OnInit {
  securityForm: UntypedFormGroup;
  saving: boolean;
  saveStatus: number;

  static appPropsToApiProps = {
    currentPassword: 'current_password',
    newPassword1: 'new_password',
    newPassword2: 'new_password_confirmation',
  };

  static apiPropsToAppProps = invert(SecurityComponent.appPropsToApiProps);

  constructor(
    private fb: UntypedFormBuilder,
    private titleService: TitleService,
    private settingsService: SettingsService,
    private authService: AuthenticationService,
    private toast: ToastNotificationsService
  ) { }

  ngOnInit() {
    this.titleService.manuallySet('Security');

    this.securityForm = this.fb.group(
      {
        currentPassword: ['', [Validators.required, Validators.minLength(8)]],
        newPassword1: ['', [Validators.required, Validators.minLength(8)]],
        newPassword2: ['', [Validators.required, Validators.minLength(8)]],
      },
      { validator: this.passwordsMatch }
    );
  }

  passwordsMatch(c: AbstractControl): { invalid: boolean } {
    if (c.get('newPassword1').value !== c.get('newPassword2').value) {
      return { invalid: true };
    }
  }

  save() {
    this.saving = true;
    this.saveStatus = 1;

    const payload = {
      current_password: this.securityForm.get('currentPassword').value,
      new_password: this.securityForm.get('newPassword1').value,
      new_password_confirmation: this.securityForm.get('newPassword2').value,
    };

    this.settingsService.savePassword(payload).subscribe({
      next: (res) => {
        if (res.data['token']) {
          this.authService.setSession(res.data['token'], res.data);
        }

        this.toast.open('You have successfully updated your password!', 'OK', NotificationType.Success);
        this.securityForm.reset();

        this.saving = false;
        this.saveStatus = 2;
        setTimeout(() => {
          this.saveStatus = null;
        }, 2000);
      },
      error: this.handleSubmissionErrors.bind(this),
    });
  }

  handleSubmissionErrors(res: HttpErrorResponse) {
    this.saveStatus = -1;
    this.saving = false;

    if (res.status === 422) {
      const errors = res.error.errors;

      for (const key in errors) {
        this.securityForm.get(SecurityComponent.apiPropsToAppProps[key]).setErrors({
          apiValidationError: errors[key].join(" "),
        });
      }
    }
  }
}
